"use client";

import { gradientPrimaryDark } from "@/themeOptions";
import { Box, SxProps, Theme } from "@mui/material";

export function SLGradientBackground({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <Box
      aria-hidden="true"
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: gradientPrimaryDark,
        backgroundSize: "cover",
        backgroundPosition: "center",
        ...sx,
      }}
    />
  );
}
